export const DEFAULT_GOOGLE_WEIGHTS = ['400'];

export const EMPTY_FONT_PICKER_VALUE = {
  source: 'uploaded',
  uuid: '',
  path: '',
  fileName: '',
  uploadedViaLogoUploader: false,
  googleFamily: 'Inter',
  googleWeight: '400',
  googleWeights: DEFAULT_GOOGLE_WEIGHTS,
  googleFiles: {},
  googleSearch: '',
};

export const getGoogleFontCssUrl = (family, weight) => {
  if (!family) return '';
  const encodedFamily = encodeURIComponent(family).replace(/%20/g, '+');
  return `https://fonts.googleapis.com/css2?family=${encodedFamily}:wght@${weight || '400'}&display=swap`;
};

export const normalizeGoogleFiles = (googleFiles) => {
  if (!googleFiles || Array.isArray(googleFiles) || typeof googleFiles !== 'object') {
    return {};
  }

  return googleFiles;
};

export const getGoogleFontFileUrl = (font) => {
  const weight = font?.googleWeight || '400';
  const files = normalizeGoogleFiles(font?.googleFiles);
  return files[weight] || files['400'] || Object.values(files)[0] || '';
};

export const normalizeFontPickerValue = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return {
      ...EMPTY_FONT_PICKER_VALUE,
      ...value,
      source: value.source === 'google' ? 'google' : 'uploaded',
      googleWeights: Array.isArray(value.googleWeights) && value.googleWeights.length
        ? value.googleWeights
        : DEFAULT_GOOGLE_WEIGHTS,
      googleFiles: normalizeGoogleFiles(value.googleFiles),
    };
  }

  if (typeof value === 'string' && value.trim()) {
    return {
      ...EMPTY_FONT_PICKER_VALUE,
      source: 'uploaded',
      path: value,
      fileName: value.split('/').pop() || '',
      uploadedViaLogoUploader: false,
    };
  }

  return { ...EMPTY_FONT_PICKER_VALUE };
};

export const isFontPickerValueSelected = (value) => {
  const normalized = normalizeFontPickerValue(value);
  if (normalized.source === 'google') {
    return !!normalized.googleFamily;
  }

  return !!normalized.path;
};
